export default __webpack_public_path__ + "static/media/HTW-110BL.2e35c7d5.png";